<pbc-filter-preset
  [filter]="offeneGutachten.preset$ | async"
  [filters]="offeneGutachten.presets$ | async"
  [name]="offeneGutachten.search$ | async"
  (select)="offeneGutachten.setFilter($event)"
  (save)="offeneGutachten.writeFilter($event)"
  (delete)="offeneGutachten.deleteFilter($event)"
></pbc-filter-preset>
